import React, { useContext } from 'react'
import { t } from '@lingui/macro'
import { AnalyticsHighlight } from '../../analytics/AnalyticsHighlight'
import { ManageCampaignContext } from '../ManageCampaignPage'
import { isCampaignImmediate } from '../utils'

export const CampaignAnalyticHighlights = ({
  analyticEventsCount,
  audienceCompletedCount,
  audienceJoinEventsCount,
  immediateUsersCount
}: {
  analyticEventsCount: number
  audienceCompletedCount: number
  audienceJoinEventsCount: number
  immediateUsersCount: number
}) => {
  const { campaign } = useContext(ManageCampaignContext)

  return (
    <div className="AnalyticsHighlight__row">
      <AnalyticsHighlight
        value={analyticEventsCount}
        description={t`Actions triggered`}
        iconColor="blue"
        icon="energy"
      />
      {!isCampaignImmediate(campaign) && (
        <>
          <AnalyticsHighlight
            value={audienceJoinEventsCount + audienceCompletedCount}
            description={t`People started`}
            iconColor="grey"
            icon="plus"
          />
          <AnalyticsHighlight
            value={audienceJoinEventsCount}
            description={t`Current audience`}
            iconColor="purple"
            icon="target"
          />
          <AnalyticsHighlight
            value={audienceCompletedCount}
            description={t`People completed`}
            iconColor="green"
            icon="check"
          />
        </>
      )}
      {isCampaignImmediate(campaign) && (
        <AnalyticsHighlight
          value={immediateUsersCount}
          description={t`Audience size`}
          iconColor="purple"
          icon="target"
        />
      )}
    </div>
  )
}
